import React from "react";
import Group20 from "../Group20";
import Plus from "../Plus";
import PhoneCall from "../PhoneCall";
import Mail from "../Mail";
import "./IPhone11ProMax19.css";

function IPhone11ProMax19(props) {
  const {
    image22,
    line16,
    line17,
    line31,
    line301,
    rectangle30,
    rectangle38,
    rectangle39,
    untitledDesign50,
    rectangle691,
    rectangle33,
    rectangle14,
    surname,
    partyLook,
    bridalLook1,
    engagementLook,
    rectangle70,
    vector2,
    aboutSohniJuneja,
    line302,
    junejasohniGmailCom,
    phone1,
    phone2,
    rectangle90,
    bridalLook2,
    event,
    artist,
    payXxxxAmountNow,
    payFullAmountTo,
    selectDate,
    selectTime,
    advanceBooking,
    fullPayment,
    location,
    selectPaymentOption,
    contactUs,
    proceedToPayment,
    bookAppointment,
    ddMmYyyy,
    select1,
    bridalLook3,
    select2,
    select3,
    vector3,
    vector4,
    vector5,
    vector6,
    line36,
    whatsapp,
    line37,
    line38,
    sjStudioDelhi,
    sjStudioDehradun,
    otherEnterBelow,
    pincode,
    state,
    locality,
    areaAndStreet,
    cityTownDistrict,
    nearbyLandmark,
    submit,
    vector7,
    loremIpsumDolorSi,
    sohniJuneja,
    rectangle692,
    readMore,
  } = props;

  return (
    <div className="container-center-horizontal">
      <div className="iphone-11-pro-max-19 screen">
        <div className="flex-row-28">
          <img className="vector-36" src="/img/vector-9@2x.png" />
          <img className="image-22-7" src={image22} />
          <div className="line-container-1">
            <img className="line-16-3" src={line16} />
            <img className="line-2" src={line17} />
            <img className="line-2" src={line31} />
          </div>
        </div>
        <div className="flex-col-32">
          <div className="overlap-group2-8">
            <img className="line-30-2" src={line301} />
            <div className="rectangle-68-2"></div>
            <img className="rectangle-30-2" src={rectangle30} />
            <div className="rectangle-36-1"></div>
            <div className="rectangle-37-1"></div>
            <Group20 />
            <img className="rectangle-38-1" src={rectangle38} />
            <img className="rectangle-39-1" src={rectangle39} />
            <div className="rectangle-44-1 border-2px-charm"></div>
            <img className="untitled-design-50-1" src={untitledDesign50} />
            <div className="rectangle-45-2 border-1px-tundora"></div>
            <img className="rectangle-69-2" src={rectangle691} />
            <img className="rectangle-33-2" src={rectangle33} />
            <img className="rectangle-14-2" src={rectangle14} />
            <div className="surname-2 poppins-medium-black-12px">{surname}</div>
            <div className="party-look-1 poppins-medium-black-12px">{partyLook}</div>
            <div className="bridal-look-6 poppins-medium-black-12px">{bridalLook1}</div>
            <div className="engagement-look-1 poppins-medium-black-12px">{engagementLook}</div>
            <img className="rectangle-70-1" src={rectangle70} />
            <img className="vector-37" src={vector2} />
            <div className="about-sohni-juneja-2 poppins-medium-tundora-16px">{aboutSohniJuneja}</div>
            <img className="line-30-3" src={line302} />
            <div className="rectangle-89-1"></div>
            <div className="junejasohnigmailcom-3 valign-text-bottom roboto-normal-tundora-15px">
              {junejasohniGmailCom}
            </div>
            <div className="phone-10 valign-text-bottom roboto-normal-tundora-15px">{phone1}</div>
            <div className="phone-11 valign-text-bottom roboto-normal-tundora-15px">{phone2}</div>
            <Plus />
            <img className="rectangle-90-1" src={rectangle90} />
            <div className="bridal-look-7 poppins-medium-tundora-14px">{bridalLook2}</div>
            <div className="event-2 poppins-normal-tundora-14px">{event}</div>
            <div className="artist-2 poppins-normal-tundora-14px">{artist}</div>
            <p className="pay-xxxx-amount-now-1 poppins-normal-tundora-10px">{payXxxxAmountNow}</p>
            <p className="pay-full-amount-to-1 poppins-normal-tundora-10px">{payFullAmountTo}</p>
            <div className="select-date-1 poppins-medium-tundora-14px">{selectDate}</div>
            <div className="select-time-1 poppins-medium-tundora-14px">{selectTime}</div>
            <div className="advance-booking-1 poppins-medium-tundora-14px">{advanceBooking}</div>
            <div className="full-payment-1 poppins-medium-tundora-14px">{fullPayment}</div>
            <div className="location-2 poppins-medium-tundora-14px">{location}</div>
            <div className="select-payment-option-1 poppins-medium-tundora-14px">{selectPaymentOption}</div>
            <div className="contact-us-10 poppins-medium-tundora-14px">{contactUs}</div>
            <div className="rectangle-91-1 border-1px-sonic-silver"></div>
            <div className="rectangle-93-1 border-1px-sonic-silver"></div>
            <div className="rectangle-97-1 border-1px-sonic-silver"></div>
            <div className="rectangle-96-1"></div>
            <div className="proceed-to-payment-1 poppins-medium-white-16px">{proceedToPayment}</div>
            <div className="book-appointment-2 poppins-semi-bold-tundora-16px">{bookAppointment}</div>
            <div className="ddmmyyyy-1 poppins-medium-gray-11px">{ddMmYyyy}</div>
            <div className="rectangle-94-1 border-1px-sonic-silver"></div>
            <div className="rectangle-92-1 border-1px-sonic-silver"></div>
            <div className="ellipse-16-1 border-2px-tundora"></div>
            <div className="ellipse-17-1 border-2px-tundora"></div>
            <div className="ellipse-18-1"></div>
            <div className="select-3 poppins-medium-gray-11px">{select1}</div>
            <div className="bridal-look-8">{bridalLook3}</div>
            <div className="select-4 poppins-medium-gray-11px">{select2}</div>
            <div className="select-5 poppins-medium-gray-11px">{select3}</div>
            <img className="vector-38" src={vector3} />
            <img className="vector-39" src={vector4} />
            <img className="vector-40" src={vector5} />
            <img className="vector-41" src={vector6} />
            <img className="line-36-6" src={line36} />
            <PhoneCall />
            <img className="whats-app-2" src={whatsapp} />
            <Mail />
            <div className="rectangle-99 border-1px-gray"></div>
            <div className="ellipse-19 border-2px-tundora"></div>
            <div className="ellipse-20 border-2px-tundora"></div>
            <div className="ellipse-21 border-2px-tundora"></div>
            <img className="line-37" src={line37} />
            <img className="line-38" src={line38} />
            <div className="rectangle-100 border-1px-gray"></div>
            <div className="sj-studio-delhi poppins-medium-tundora-14px">{sjStudioDelhi}</div>
            <div className="sj-studio-dehradun-1 poppins-medium-tundora-14px">{sjStudioDehradun}</div>
            <div className="other-enter-below poppins-medium-tundora-14px">{otherEnterBelow}</div>
            <div className="ellipse-19-1"></div>
            <div className="rectangle-101"></div>
            <div className="rectangle-105 border-1px-mist-gray"></div>
            <div className="rectangle-106 border-1px-mist-gray"></div>
            <div className="rectangle-104 border-1px-mist-gray"></div>
            <div className="rectangle-102 border-1px-mist-gray"></div>
            <div className="rectangle-107"></div>
            <div className="rectangle-103 border-1px-mist-gray"></div>
            <div className="pincode poppins-normal-gray-9px">{pincode}</div>
            <div className="state poppins-normal-gray-9px">{state}</div>
            <div className="locality poppins-normal-gray-9px">{locality}</div>
            <div className="area-and-street poppins-normal-gray-9px">{areaAndStreet}</div>
            <div className="city-town-district poppins-normal-gray-9px">{cityTownDistrict}</div>
            <div className="nearby-landmark poppins-normal-gray-9px">{nearbyLandmark}</div>
            <div className="submit">{submit}</div>
            <img className="vector-42" src={vector7} />
          </div>
          <div className="flex-row-29">
            <div className="overlap-group4-1">
              <p className="lorem-ipsum-dolor-si-3 montserrat-normal-tundora-8px">{loremIpsumDolorSi}</p>
              <div className="sohni-juneja-1 poppins-medium-tundora-16px">{sohniJuneja}</div>
            </div>
            <img className="rectangle-69-3" src={rectangle692} />
          </div>
          <div className="overlap-group3-2">
            <div className="rectangle-68-3"></div>
            <div className="read-more-1 montserrat-semi-bold-white-8px">{readMore}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IPhone11ProMax19;
